import { render } from "./dialog-search.vue?vue&type=template&id=5c867014&scoped=true"
import script from "./dialog-search.vue?vue&type=script&lang=js"
export * from "./dialog-search.vue?vue&type=script&lang=js"

import "./dialog-search.vue?vue&type=style&index=0&id=5c867014&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c867014"]])

export default __exports__